<template>
  <transition name='fade'>
    <div
      class="modal headimg_box"
      v-if='visible'
    >
      <div
        class="headimg"
        element-loading-text="添加中，请稍后"
      >
        <div class="title msp_icon_close">
          <span class="title_name">请先安装最新版浏览器插件，再继续操作</span>
          <span
            class="iconfont el-icon-close"
            @click.stop='closeBox()'
          ></span>
        </div>

        <div
          class="browser_info"
          ref="browserInfo"
        >
          <el-carousel
            :height="`${height}px`"
            trigger="click"
            :interval="4000"
            arrow="always"
          >
            <el-carousel-item
              v-for="item in datas"
              :key="item.url"
            >
              <div class="browser_title">{{item.title}}</div>
              <div class="browser_detail">{{item.detail}}</div>
              <div class="browser_img">
                <img
                  :src="`../../../static/img/browser${item.url}.jpg`"
                  class="banner"
                  ref="banner"
                >
              </div>
            </el-carousel-item>
          </el-carousel>

        </div>

        <div class="headimg_buttom">
          <el-button type="primary">
            <a
              href="https://gyshuzhi.oss-cn-hangzhou.aliyuncs.com/company-admin-4j/sz/chrome-extension.zip"
              download="chrome-extension.zip"
            >下载插件</a>
          </el-button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'

export default {
  name: 'browserplug',
  data () {
    return {
      visible: false,
      datas: [
        { url: 1, title: '插件安装第一步', detail: '在界面中下载插件，并找到插件的位置；插件格式为压缩包，不用解压。' },
        { url: 2, title: '插件安装第二步', detail: '在右上角的设置（三个点）中，找到【更多工具】下的【扩展程序】，点击后进入对应界面' },
        { url: 3, title: '插件安装第三步', detail: '在扩展程序页面，开启右上角开发者模式后，缩小浏览器界面，将刚才下载的压缩包拖入浏览器中，即可安装完成！' },
      ],
      height: 600
    }
  },
  mounted () {
    this.$root.eventHub.$on('browserplugModel', (data) => {
      this.visible = true
    })
  },
  destroyed () {
    this.$root.eventHub.$off('browserplugModel')
  },


  methods: {
    closeBox () {
      this.visible = false
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.headimg_box
  .headimg
    position relative
    width 80%
    height 700px
    border-radius 6px
    background #E9EAEC

    .title
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 48px
      border-bottom 1px solid #E4E7ED
      background #fff

      .title_name
        span-medium-title()
        float left
        line-height 48px

      .iconfont
        float right
        font-size 22px
        line-height 48px
        cursor pointer

    .browser_info
      height calc(100% - 110px)

      .browser_title
        box-sizing border-box
        margin-top 20px
        margin-bottom 20px
        color #fd4a4a
        text-align center
        font-weight bold
        font-size 24px

      .browser_detail
        margin-bottom 20px
        color #606266
        text-align center
        font-weight bold
        font-size 20px

      .browser_img
        display flex
        justify-content center

        img
          max-width 100%
          max-height 440px

    .headimg_buttom
      position absolute
      bottom 20px
      display flex
      justify-content flex-end
      box-sizing border-box
      padding-right 20px
      width 100%
      border-radius 0 0 6px 6px

      button
        width 74px
        height 28px
        center()
        line-height 0
</style>
